import React from 'react';
import { Link } from 'react-router-dom';
import { Video, Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_media-stage-25/artifacts/qiil6l84_brand%20stage%20logo.png";

export default function Footer() {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img data-testid="footer-brand-logo"
                src={LOGO_URL} 
                alt="BrandStage" 
                className="h-10 w-auto rounded"
              />
            </Link>
            <p className="text-zinc-500 text-sm leading-relaxed mb-6">
              Professional video interviews that capture leadership vision and build digital influence.
            </p>
            <p className="text-zinc-600 text-xs">A brand of Continex Tradeline India Private Limited</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-zinc-500 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/#services" className="text-zinc-400 hover:text-white transition-colors text-sm">Services</a></li>
              <li><a href="/#process" className="text-zinc-400 hover:text-white transition-colors text-sm">How It Works</a></li>
              <li><a href="/#pricing" className="text-zinc-400 hover:text-white transition-colors text-sm">Pricing</a></li>
              <li><Link to="/about" className="text-zinc-400 hover:text-white transition-colors text-sm">About Us</Link></li>
              <li><Link to="/video-guidelines" className="text-zinc-400 hover:text-white transition-colors text-sm">Video Guidelines</Link></li>
              <li><Link to="/help" className="text-zinc-400 hover:text-white transition-colors text-sm">Help Center</Link></li>
              <li><Link to="/referral-programme" className="text-zinc-400 hover:text-white transition-colors text-sm">Referral Programme</Link></li>
              <li><Link to="/guide" className="text-zinc-400 hover:text-white transition-colors text-sm">Quick Guide</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-zinc-500 mb-4">Services</h4>
            <ul className="space-y-3">
              <li><span className="text-zinc-400 text-sm">Trade Show Videos</span></li>
              <li><span className="text-zinc-400 text-sm">Leadership Interviews</span></li>
              <li><span className="text-zinc-400 text-sm">Corporate Testimonials</span></li>
              <li><span className="text-zinc-400 text-sm">Quick Bite Videos</span></li>
            </ul>
            
            {/* Legal Links */}
            <h4 className="text-sm font-bold uppercase tracking-widest text-zinc-500 mb-4 mt-8">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/terms" className="text-zinc-400 hover:text-white transition-colors text-sm">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-zinc-400 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/compliance" className="text-zinc-400 hover:text-white transition-colors text-sm">Compliance</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-zinc-500 mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-zinc-400 text-sm">
                <Mail className="w-4 h-4" />
                <a href="mailto:operations@brandstage-media.com" className="hover:text-white transition-colors">operations@brandstage-media.com</a>
              </li>
              <li className="flex items-center gap-3 text-zinc-400 text-sm">
                <Phone className="w-4 h-4" />
                <a href="tel:+919003035900" className="hover:text-white transition-colors">+91 9003035900</a>
              </li>
              <li className="flex items-start gap-3 text-zinc-400 text-sm">
                <MapPin className="w-4 h-4 mt-1" />
                <span>Bengaluru, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">© 2026 BrandStage Media. All rights reserved.</p>
          <div className="flex items-center gap-4 text-zinc-500 text-sm">
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <span>•</span>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <span>•</span>
            <Link to="/compliance" className="hover:text-white transition-colors">Compliance</Link>
            <span>•</span>
            <Link to="/about" className="hover:text-white transition-colors">About</Link>
          </div>
          <p className="text-zinc-500 text-sm">
            A <a href="https://continex.in" target="_blank" rel="noopener noreferrer" className="text-[#C41E3A] hover:underline">Continex</a> Initiative • Powered by <a href="https://www.cinimage.org" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">CINIMAGE</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
